module.exports = __webpack_public_path__ + "img/msapplication-icon-144x144.059e21e7.png";